(() => {
  const root = document.querySelector('.element-collection[data-product-scope]');
  if (!root) return;
  const symbol = new URLSearchParams(window.location.search).get('element');
  if (!symbol || !/^[A-Z][a-z]?$/.test(symbol)) return;
  // Multiple/empty native filter results must stay authoritative. Grouped requests
  // intentionally use one element, so they cannot replace a combined filter view.
  if (Number(root.dataset.activeFilterCount) !== 1 || Number(root.dataset.filteredProductCount) < 1) return;
  if (root.dataset.activePrimary !== symbol && root.dataset.activeConstituent !== symbol) return;
  const selected = [...root.querySelectorAll('[data-element-symbol]')].find((link) => link.dataset.elementSymbol === symbol);
  if (!selected) return;

  selected.classList.add('periodic-table__element--active');
  selected.setAttribute('aria-current', 'true');
  const clear = root.querySelector('[data-clear-element]');
  if (clear) clear.hidden = false;
  const name = selected.dataset.elementName;
  root.querySelector('[data-default-products]').hidden = true;
  const results = root.querySelector('[data-element-results]');
  results.hidden = false;
  const groups = {
    pure: results.querySelector('[data-element-group="pure"]'),
    containing: results.querySelector('[data-element-group="containing"]')
  };
  groups.pure.querySelector('[data-group-heading]').textContent = `${name} Products`;
  groups.containing.querySelector('[data-group-heading]').textContent = `Materials Containing ${name}`;

  async function load(group, pageUrl) {
    group.setAttribute('aria-busy', 'true');
    const originalHeading = group.querySelector('[data-group-heading]');
    const heading = originalHeading?.textContent ?? '';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const url = new URL(pageUrl, window.location.origin);
      url.searchParams.set('section_id', root.dataset.sectionId);
      const response = await fetch(url, { headers: { Accept: 'text/html' }, signal: controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const remote = html.querySelector('.element-collection');
      const expected = group.dataset.elementGroup === 'pure' ? remote?.dataset.activePrimary : remote?.dataset.activeConstituent;
      if (expected !== symbol) throw new Error('The storefront filter is not active.');
      const content = remote.querySelector('.element-collection__results');
      if (!content) throw new Error('Filtered product section is missing.');
      content.querySelector('h2')?.remove();
      content.querySelector('.element-collection__count')?.remove();
      if (group.dataset.elementGroup === 'containing') {
        content.querySelectorAll('.material-card').forEach((card) => {
          if (card.dataset.primaryElement === symbol) card.remove();
        });
      }
      const newHeading = document.createElement('h2');
      newHeading.dataset.groupHeading = '';
      newHeading.textContent = heading;
      group.replaceChildren(newHeading, ...content.children);
      if (!group.querySelector('.material-card') && !group.querySelector('.basis-pagination')) {
        const empty = document.createElement('p');
        empty.textContent = group.dataset.elementGroup === 'pure'
          ? `No pure ${name.toLowerCase()} products are listed yet.`
          : `No materials containing ${name.toLowerCase()} are listed yet.`;
        group.replaceChildren(newHeading, empty);
      }
    } catch (error) {
      const message = document.createElement('p');
      message.textContent = `Could not load ${heading.toLowerCase()} here.`;
      const link = document.createElement('a');
      link.href = pageUrl;
      link.textContent = `Browse ${heading.toLowerCase()} directly →`;
      group.replaceChildren(originalHeading, message, link);
      console.warn('Element discovery:', error.message);
    } finally {
      clearTimeout(timeout);
      group.removeAttribute('aria-busy');
    }
  }

  const base = new URL(root.dataset.collectionUrl, window.location.origin);
  const pure = new URL(base);
  pure.searchParams.set('filter.p.m.custom.element', symbol);
  const containing = new URL(base);
  containing.searchParams.set('filter.p.m.custom.constituent_elements', symbol);
  if (Number(selected.dataset.pureCount) > 0) load(groups.pure, pure);
  else groups.pure.lastElementChild.textContent = `No pure ${name.toLowerCase()} products are listed yet.`;
  if (Number(selected.dataset.constituentCount) > 0) load(groups.containing, containing);
  else groups.containing.lastElementChild.textContent = `No materials containing ${name.toLowerCase()} are listed yet.`;

  results.addEventListener('click', (event) => {
    const link = event.target.closest('.basis-pagination a');
    const group = link?.closest('[data-element-group]');
    if (!group) return;
    event.preventDefault();
    load(group, link.href);
    group.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
